import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { getPasswordResetResultSummary } from '../tenantHelpers';

const PasswordResetResultModal = ({ result, isOpen, onClose }) => {
  if (!isOpen || !result) return null;

  const summary = getPasswordResetResultSummary(result);
  const title = summary.isTotalFailure
    ? 'Password reset failed'
    : 'Password reset completed with some issues';

  return (
    <div className="stm-modal-overlay" onClick={onClose}>
      <div className="stm-modal stm-modal--sm" onClick={(event) => event.stopPropagation()}>
        <header className="stm-modal__header">
          <div>
            <h2>{title}</h2>
          </div>
          <button type="button" className="stm-icon-btn" onClick={onClose} aria-label="Close">
            <FaTimes />
          </button>
        </header>
        <div className="stm-modal__body">
          <div className="stm-result-stats">
            <div><span>Successful</span><strong>{summary.successfulCount}</strong></div>
            <div><span>Failed</span><strong>{summary.failedCount}</strong></div>
            <div><span>Invalid</span><strong>{summary.invalidCount}</strong></div>
          </div>

          {summary.failedResets.length > 0 && (
            <div className="stm-result-list">
              <p className="stm-modal__label">Failed users</p>
              <ul>
                {summary.failedResets.map((entry) => (
                  <li key={entry.user}>
                    <strong>{entry.user}</strong>
                    <span>{entry.reason || 'Reset failed.'}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {summary.invalidUsers.length > 0 && (
            <div className="stm-result-list">
              <p className="stm-modal__label">Invalid users</p>
              <ul>
                {summary.invalidUsers.map((user) => (
                  <li key={user}><strong>{user}</strong></li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <footer className="stm-modal__footer">
          <button type="button" className="stm-btn stm-btn--primary" onClick={onClose}>Close</button>
        </footer>
      </div>
    </div>
  );
};

export default PasswordResetResultModal;
